// extracted by mini-css-extract-plugin
export default {"carousel-wrapper":"spotlight_carousel-wrapper__fnIPW"};